module.exports = __webpack_public_path__ + "static/media/insturctor1.8c8246d8.png";